import React, { useContext, useState } from "react";
import { GlobalInfo } from "../App";

export default function Status(props) {
  const { val, acc, getupdate } = useContext(GlobalInfo);
  const [clockState, setClockstate] = useState();
  setInterval(() => {
    var x = props.arr.deadline;
    const time = new Date(x * 1000);
    setClockstate(time.toLocaleDateString());
    // console.log(clockState);
  }, 1000);
  const approve = async (a) => {
    const { web3, contract } = val;

    await contract.isApproved(props.arr.id, true, {
      from: acc,
    });
    getupdate();
    //  console.log(a);
  };
  return (
    <>
      <center>
        <h1>Status</h1>
        {console.log(props?.arr.approved)}
        <h1>id:-{props.arr.id}</h1>
        <h1>Category:-{props.arr.category}</h1>
        <h2>Description:-{props.arr.description}</h2>
        <h3>Target:-{props.arr.target}</h3>
        <h4>Deadline:-{clockState}</h4>
        <h5>FundRaised:-{props.arr.raisedAmount}</h5>
        <h6>Receipient:-{props.arr.recipient}</h6>
        <h1>{props?.arr?.approved ? "true" : "false"}</h1>
        <h6>No of Donors:- {props.arr.noOfDonors}</h6>
        {<img src={props.arr.file_hash} width="400px" alt="get img" />}
        <button
          onClick={() => {
            approve(true);
          }}
        >
          Approve
        </button>
        <button
          onClick={() => {
            approve(false);
          }}
        >
          Reject
        </button>
      </center>
    </>
  );
}
